import { create } from "zustand";
import { type AddedProductSnapshot } from "@/composites/cart/AddToCartSliderContent";

export type { AddedProductSnapshot };

interface AddToCartSliderStore {
	isOpen: boolean;
	addedProduct: AddedProductSnapshot | null;
	open: (product: AddedProductSnapshot) => void;
	close: () => void;
}

export const useAddToCartSliderStore = create<AddToCartSliderStore>((set) => ({
	isOpen: false,
	addedProduct: null,
	open: (product: AddedProductSnapshot): void => {
		set({ isOpen: true, addedProduct: product });
	},
	close: (): void => {
		set({ isOpen: false });
	}
}));
